import React from 'react';
import {connect} from 'react-redux'
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import useClasses from '../../../../../../helpers/useClasses';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content'
  },
  avatar: {
    width: 60,
    height: 60
  },
  name: {
    marginTop: theme.spacing(1),
    color: '#fff'
  },
  bio: {
    color: '#fff'
  }
});

const Profile = props => {
  const { className, user } = props;

  const classes = useClasses(styles);

  return (
    <div
      className={clsx(classes.root, className)}
    >
      <Typography
        // className={classes.name}
        variant="h4"
        sx={{
          marginTop: '8px',
          color: '#fff'
        }}
      >
        {(user && user.first_name )|| ''} {(user && user.last_name) || ''}
      </Typography>
      <Typography
        // className={classes.bio}
        variant="body2"
        sx={{
          color: '#fff'
        }}
      >
        {(user && user.account_name) || ''}
      </Typography>
    </div>
  );
};

Profile.propTypes = {
  className: PropTypes.string
};

const mapStateToProps = state => {
  return {
    user: state.auth.user
  }
}

export default connect(mapStateToProps)(Profile)
